"use client";
import { ChangeEvent, ElementType, FunctionComponent, HTMLProps } from "react";
import "./form.scss";
import classNames from "classnames";
interface Field2Props extends HTMLProps<HTMLInputElement> {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  wrapperclass?: string;
  Icon?: ElementType;
  iconClass?: string;
  hasError?: boolean;
}

const Field2: FunctionComponent<Field2Props> = (props) => {
  const {
    value,
    onChange,
    wrapperclass,
    Icon,
    iconClass,
    hasError,

    ...otherProps
  } = props;
  const containerClass = classNames(
    "flex flex-middle ba-solid br-6 field2-container h-10 ",
    wrapperclass,
    hasError ? "error-border" : "bc-line-500"
  );
  return (
    <>
      <div className={containerClass}>
        {Icon ? (
          <div className="ml-4 h-6">
            <Icon className={iconClass} />
          </div>
        ) : null}
        <input value={value} onChange={onChange} {...otherProps} />
      </div>
    </>
  );
};

export default Field2;
